/* tslint:disable */

declare var Object: any;
export interface ViewEmpReqInterface {
  "empId"?: string;
  "fullName"?: string;
  "posNameEn"?: string;
  "reqType": string;
  "reqDate": Date;
  "status": number;
  "modifiedDate": Date;
  "lastModifiedBy"?: string;
  "outstandingList"?: string;
  "reqNo": string;
}

export class ViewEmpReq implements ViewEmpReqInterface {
  "empId": string;
  "fullName": string;
  "posNameEn": string;
  "reqType": string;
  "reqDate": Date;
  "status": number;
  "modifiedDate": Date;
  "lastModifiedBy": string;
  "outstandingList": string;
  "reqNo": string;
  constructor(data?: ViewEmpReqInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewEmpReq`.
   */
  public static getModelName() {
    return "ViewEmpReq";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewEmpReq for dynamic purposes.
  **/
  public static factory(data: ViewEmpReqInterface): ViewEmpReq{
    return new ViewEmpReq(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewEmpReq',
      plural: 'ViewEmpReqs',
      path: 'ViewEmpReqs',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "posNameEn": {
          name: 'posNameEn',
          type: 'string'
        },
        "reqType": {
          name: 'reqType',
          type: 'string'
        },
        "reqDate": {
          name: 'reqDate',
          type: 'Date'
        },
        "status": {
          name: 'status',
          type: 'number'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "lastModifiedBy": {
          name: 'lastModifiedBy',
          type: 'string'
        },
        "outstandingList": {
          name: 'outstandingList',
          type: 'string'
        },
        "reqNo": {
          name: 'reqNo',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewEmpReq.ts